import { getField, updateField } from 'vuex-map-fields';

const getters = {
    getField,
};

const state = {
    salesOrder: {},
    showConfirmationModal: false,
    confirmationModalText: '',
    confirmationModalAction: null,
    shipping_country: {},

    showDeleteOrderConfirmationModal: false,

    showDesignRejectedModal: false,
    design_rejected_reason: "",

    form: {
        items: [],
        order_items: [],
        ship_date: '',
        delivery_date: '',
        due_date: '',
        can_ship_early: 0,
        new_product_id: null,
        new_product_qty: null,
        override_new_product_price: 0,

        add_new_fee: 0,
        new_fee_id: null,
        new_fee_description: '',
        new_fee_amount: '',

        add_new_discount: 0,
        new_discount_description: '',
        new_discount_amount: '',

        payment_token: '',
        payment_amount: '',

        add_new_admin_note: 0,
        new_admin_note: '',

        add_new_decorator_note: 0,
        new_decorator_note: '',

        use_existing_card: 1
    },
};

const mutations = {
    updateField,

    setSalesOrder(state, salesOrder) {
        state.salesOrder = salesOrder;
    },
    showHistory(state, flag) {
        state.showHistory = flag;
    },
    showConfirmationModal(state, flag) {
        state.showConfirmationModal = flag
    },
    setConfirmationModalText(state, text) {
        state.confirmationModalText = text
    },
    setConfirmationModalAction(state, action) {
        state.confirmationModalAction = action
    },
    setShowDeleteOrderConfirmationModal(state, flag) {
        state.showDeleteOrderConfirmationModal = flag
    }
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};